import { all, always, cond, filter, length, pipe, T, values } from 'ramda';
import { isFalsy, isTruthy } from 'ramda-adjunct';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { TMediaTypes } from '../../../utils/hoc/withMediaTypes/withMediaTypes.types';

export const useMediaTypesLabel = (mediaTypes: TMediaTypes) => {
  const { formatMessage } = useIntl();
  return useMemo(
    () =>
      cond([
        [pipe(values, all(isTruthy)), always(formatMessage({ id: 'media-type-select-numbers.all' }))],
        [pipe(values, all(isFalsy)), always(formatMessage({ id: 'media-type-select-numbers.all' }))],
        [
          T,
          always(
            formatMessage(
              { id: 'media-type-select-numbers.some' },
              {
                count: pipe(values, filter(isTruthy), length)(mediaTypes),
              },
            ),
          ),
        ],
      ])(mediaTypes),
    [mediaTypes],
  );
};
